import { createFileRoute } from '@tanstack/react-router';
import { Favourites } from '@/components/Modules/Favourites';

export const Route = createFileRoute('/favourites')({
  component: Favourites,
});
